<template>
    <div class="continer">
        <pageHeader ></pageHeader>
        <background>
            <div class="content">
                <div class="tips">
                    <div>如图示</div>
                    <div>放入纸张后点击开始扫描</div>
                </div>
                <div class="img">
                    <img src="@/assets/images/busImage/scan.gif" style="width:100%;height:100%"/>
                </div>
                <div class="scan-btn" @click="startScan">开 始 扫 描</div>
            </div>
        </background>
    </div>
</template>

<script>
import pageHeader from './components/pageHeader'
import background from '@/components/background'
export default {
    components: { pageHeader,background },
    data(){
        return {}
    },
    mounted(){
        this.$emit('PlaySound','scanBegin');
    },
    methods: {
        
        startScan(){
            this.$router.push({name: 'fileEditImage'})
        }
    }
}
</script>

<style lang="less" scoped>
    .continer {
        height: 100%;
        width: 100%;
    }
    .content {
        position: absolute;
        top: 233px;
        left: calc(50% - 228px);
        .tips {
            font-weight: 400;
            font-size: 32px;
            color: #000000;
            letter-spacing: 2px;
            text-align: center;
        }
        .img{
            width: 456px;
            height: 456px;
            margin: 40px 0;
            background: #FAFAFA;
            border-radius: 8px;
            border: 2px solid rgba(0,0,0,0.06);
        }
        .scan-btn {
            padding: 20px 153px;
            background: radial-gradient( 0% 141% at -1% 0%, #C62D2F 0%, #B23B34 100%);
            border-radius: 8px;
            font-weight: 400;
            font-size: 28px;
            color: #FFFFFF;
        }
    }
    .cancle-btn {
            position: absolute;
            padding: 17px 22px;
            top: 42px;
            right: 40px;
            background: rgba(239,239,239,0.5);
            border-radius: 8px;
            font-size: 32px;
            text-align: center;
            color: #FFFFFF;
        }
</style>
